import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { DataViewRoutingModule } from "./data-view-routing.module";
import { PresetManagerComponent } from "./preset-manager/preset-manager.component";
import { SharedModule } from "@app/view/shared";
import { JobTableViewerComponent } from "@app/view/data-view/job-table-viewer/job-table-viewer.component";
import { VisitTableViewerComponent } from "./visit-table-viewer/visit-table-viewer.component";
import { NewPresetDialogComponent } from "./new-preset-dialog/new-preset-dialog.component";
import { OpenPresetDialogComponent } from "./open-preset-dialog/open-preset-dialog.component";
import { SavePresetDialogComponent } from "./save-preset-dialog/save-preset-dialog.component";
import { DeletePresetDialogComponent } from "./delete-preset-dialog/delete-preset-dialog.component";
import { TicketTableViewerComponent } from "./ticket-table-viewer/ticket-table-viewer.component";
import { MeetingTableViewerComponent } from "./meeting-table-viewer/meeting-table-viewer.component";

@NgModule({
  exports: [VisitTableViewerComponent],
  imports: [
    DataViewRoutingModule,
    CommonModule,
    SharedModule,
    PresetManagerComponent,
    JobTableViewerComponent,
    VisitTableViewerComponent,
    NewPresetDialogComponent,
    OpenPresetDialogComponent,
    SavePresetDialogComponent,
    DeletePresetDialogComponent,
    TicketTableViewerComponent,
    MeetingTableViewerComponent
  ]
})
export class DataViewModule {}
